import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { AdjustmentNotesService } from "../adjustment-notes/adjustment.service";
import { PurchasesService } from "./purchases.service";
import { PurchaseProductDetailedReqDto, PurchaseProductFilterReq, PurchaseRequest } from "@gtpl/shared-models/finance";
import { CommonResponse } from "@gtpl/shared-models/masters";

@ApiTags('purchases')
@Controller('purchases')
export class PurchasesController {
    constructor(
        private service: PurchasesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) {
    }
    @Post('/createPurchase')
    async createPurchase(@Body() data:PurchaseRequest,isUpdate:boolean): Promise<CommonResponse>{
       try{
        return this.service.createPurchase(data,false);
       } catch(err){
        return this.applicationExceptionHandler.returnException(CommonResponse,err);
       }
    }
    @Post('/updatePurchase')
    async updatePurchase(@Body() data:PurchaseRequest,isUpdate:boolean): Promise<CommonResponse>{
       try{
        return this.service.createPurchase(data,true);
       } catch(err){
        return this.applicationExceptionHandler.returnException(CommonResponse,err);
       }
    }
    @Post('/getAllProducts')
    async getAllProducts(): Promise<CommonResponse>{
       try{
        return this.service.getAllProducts();
       } catch(err){
        return this.applicationExceptionHandler.returnException(CommonResponse,err);
       }
    }

    @Post('/getViewForAllProducts')
    @ApiBody({type:PurchaseProductFilterReq})
    async getViewForAllProducts(@Body() req:PurchaseProductFilterReq): Promise<CommonResponse>{
       try{
        return this.service.getViewForAllProducts(req);
       } catch(err){
        return this.applicationExceptionHandler.returnException(CommonResponse,err);
       }
    }

    @Post('/getAllVendorNamesForView')
    async getAllVendorNamesForView(): Promise<CommonResponse>{
       try{
        return this.service.getAllVendorNamesForView();
       } catch(err){
        return this.applicationExceptionHandler.returnException(CommonResponse,err);
       }
    }

    @Post('/getAllInvoiceNumber')
    async getAllInvoiceNumber(): Promise<CommonResponse>{
       try{
        return this.service.getAllInvoiceNumber();
       } catch(err){
        return this.applicationExceptionHandler.returnException(CommonResponse,err);
       }
    }

    @Post('/getAllUnits')
    async getAllUnits(): Promise<CommonResponse>{
       try{
        return this.service.getAllUnits();
       } catch(err){
        return this.applicationExceptionHandler.returnException(CommonResponse,err);
       }
    }


    @Post('/getDetailedViewForProductPurchase')
@ApiBody({type:PurchaseProductDetailedReqDto})
async getDetailedViewForProductPurchase(@Body() req: PurchaseProductDetailedReqDto): Promise<CommonResponse> {
  try {
    // console.log(saleOrderIdRequest);
    return await this.service.getDetailedViewForProductPurchase(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(CommonResponse, error);
  }
}
}